<script setup lang="ts">
// Vue
import { onMounted, watch, ref } from "vue";

// ///////////////////
// Props
// ///////////////////

const props = defineProps<{
  show?: () => boolean;
}>();

// ///////////////////
// Refs
// ///////////////////

const overlay = ref();
const showOverlay = ref<boolean>(false);

// ///////////////////
// Lifecycle
// ///////////////////

// Set the showOverlay ref to true (or props.show() if using show prop) when the component is mounted
onMounted(() => {
  if (props.show) {
    showOverlay.value = props.show();
  } else {
    showOverlay.value = true;
  }
});

// ///////////////////
// Watchers
// ///////////////////

// Watch for changes in the optional show prop and update the showOverlay ref accordingly
watch(
  () => props.show && props.show(),
  (newVal) => {
    showOverlay.value = newVal !== undefined ? newVal : false;
  }
);
</script>

<template>
  <Teleport to="#overlay">
    <Transition
      name="overlay"
      appear>
      <div
        v-if="showOverlay"
        ref="overlay"
        class="z-modal bg-scrim/60 fixed inset-0 flex flex-col items-center justify-center backdrop-blur-sm"
        tabindex="0"
        @click.stop>
        <slot></slot>
      </div>
    </Transition>
  </Teleport>
</template>

<style>
.overlay-enter-active,
.overlay-leave-active,
.overlay-enter-active .overlay-container,
.overlay-leave-active .overlay-container {
  transition:
    opacity 0.3s ease-out,
    transform 0.3s ease-out;
}

.overlay-enter-from {
  opacity: 0;
}

.overlay-leave-to {
  opacity: 0;
}

.overlay-enter-from .overlay-container {
  -webkit-transform: scale(1.05);
  transform: scale(1.05);
}

.overlay-leave-to .overlay-container {
  -webkit-transform: scale(0.95);
  transform: scale(0.95);
}
</style>
